// Yeni bir Button component'i oluşturalım
export function Button({ children, className = '', disabled, onClick, ...props }) {
  return (
    <button
      className={`px-4 py-2 rounded-md text-sm font-medium transition 
        ${disabled ? 'opacity-60 cursor-not-allowed' : 'hover:opacity-90'} 
        ${className}`}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
} 